document.addEventListener("DOMContentLoaded", function() {
  const wishlistKey = 'my_wishlist_data';

  // Get wishlist from localStorage
  function getWishlist() {
    return JSON.parse(localStorage.getItem(wishlistKey)) || [];
  }

  // Save wishlist to localStorage
  function saveWishlist(wishlist) {
    localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
  }

  // Add item to wishlist
  function addToWishlist(productId, button) {
    const wishlist = getWishlist();
    if (!wishlist.includes(productId)) {
      wishlist.push(productId);
      saveWishlist(wishlist);
      button.classList.add('in-wishlist');
      showMessage('Product added to wishlist!', button);
      openWishlistPopup();  // Open popup when item is added
      renderWishlist();
    } else {
      showMessage('Product is already in wishlist.', button);
    }
  }

  // Remove item from wishlist
  function removeFromWishlist(productId, button) {
    let wishlist = getWishlist();
    wishlist = wishlist.filter(id => id !== productId);
    saveWishlist(wishlist);
    if (button) {
      button.classList.remove('in-wishlist');
      showMessage('Product removed from wishlist!', button);
    }
    renderWishlist();
  }

  // Show message after adding/removing item
  function showMessage(message, button) {
    const messageSpan = button.nextElementSibling;
    messageSpan.textContent = message;
    messageSpan.classList.add('show-message');
    setTimeout(() => {
      messageSpan.classList.remove('show-message');
    }, 3000); // Message will stay for 3 seconds
  }

  // Render wishlist buttons (handles adding/removing)
  function renderWishlistButtons() {
    const wishlist = getWishlist();
    document.querySelectorAll('.add-to-wishlist').forEach(button => {
      const productId = button.getAttribute('data-product-handler');
      if (wishlist.includes(productId)) {
        button.classList.add('in-wishlist');
      }
    });
  }

  // Render wishlist inside popup
  function renderWishlist() {
    const wishlist = getWishlist();
    const wishlistItemsContainer = document.getElementById('wishlist-items');
    if (!wishlistItemsContainer) return;

    wishlistItemsContainer.innerHTML = '';
    //alert(wishlist.length);
    if (wishlist.length === 0) {
      wishlistItemsContainer.innerHTML = '<label>There is no items in wishlist box</label>';
      $('.wishlist-items-active').html('');
      $('.cs-wishlist-count').html('('+wishlist.length+')');
      return;
    }
    //var count_data = wishlist.length - 3;
    $('.cs-wishlist-count').html('('+wishlist.length+')');
    //${Shopify.currency.active}
    wishlist.forEach(productId => {
      fetch(`/products/${productId}.js`)
        .then(response => response.json())
        .then(product => {

          //$('.cs-product-added-data').text("${product.title}");
           //$('.scs-added').show();
          $('.wishlist-items-active').html('');
          const productElement = document.createElement('div');
          productElement.classList.add('wishlist-item');
          productElement.innerHTML = `
            <div class="product-info">
            
            <div class='cs-p-img'>
              <img src="${product.images[0]}" alt="${product.title}" />
                <button class="remove-from-wishlist" data-product-handler="${productId}">×</button>
                <p class="cs-cart-btn com"><button class="add-to-cart" data-product-handler="${productId}"><img src="https://cdn.shopify.com/s/files/1/0064/1004/3476/files/cart.svg?v=1720065437" class="cs-cart-icon"></button></p>
              </div>
              <div>
              <p>Price: ${product.price / 100}</p>
                <a href="/products/${product.handle}">${product.title}</a>
                
                
              
              </div>
            </div>
          `;
          
          wishlistItemsContainer.appendChild(productElement);
          const wishlistItemsContainer1 = document.getElementById('cs-scs-added');
          const productElement1 = document.createElement('div');
          productElement1.classList.add('wishlist-items-active');
          productElement1.innerHTML = `
            <div class="cs-product-info">${product.title} has added to wishlist successful</div>
            </div>
          `;
          wishlistItemsContainer1.appendChild(productElement1);
        })
        .then(() => {
          document.querySelectorAll('.remove-from-wishlist').forEach(button => {
            button.addEventListener('click', function() {
              const productId = this.getAttribute('data-product-handler');
              removeFromWishlist(productId, null);  // Null because button isn't needed

              location.reload();
            });
          });

          // Add to Cart functionality
          document.querySelectorAll('.add-to-cart').forEach(button => {
            button.addEventListener('click', function() {
              const productId = this.getAttribute('data-product-handler');
              addToCart(productId);
            });
          });
        });
    });
  }

  // Function to open wishlist popup
  function openWishlistPopup() {
    document.getElementById('wishlist-popup').style.display = 'block';
  }

  // Function to close wishlist popup
  function closeWishlistPopup() {
    document.getElementById('wishlist-popup').style.display = 'none';
  }

  // Close popup when clicking outside or on close button
  document.getElementById('close-wishlist-popup').addEventListener('click', closeWishlistPopup);
  window.addEventListener('click', function(event) {
    const popup = document.getElementById('wishlist-popup');
    if (event.target == popup) {
      closeWishlistPopup();
    }
  });

 

  // Add to Cart function (Shopify Ajax API)
  function addToCart(productId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      //alert('Item added to cart successfully!');
      window.location.replace("https://www.internationaltie.com/cart");
      console.log(data);
    })
    .catch(error => {
      alert('Error adding item to cart.');
      console.error(error);
    });
  }

  // Initial event listeners for adding/removing items from wishlist
  document.querySelectorAll('.add-to-wishlist').forEach(button => {
    button.addEventListener('click', function() {
      const productId = this.getAttribute('data-product-handler');
      if (this.classList.contains('in-wishlist')) {
        removeFromWishlist(productId, this);
      } else {
        addToWishlist(productId, this);
      }
    });
  });

  // Render the wishlist buttons and items on page load
  renderWishlistButtons();
  renderWishlist();
});



